import { useState } from "react";
import { useSite } from "@/lib/content";
import { cleanBi } from "@/lib/adminApi";
import { t } from "@/lib/i18n";
import { BiFieldEditor, SaveButton, SectionHeader, useSaver } from "@/pages/admin/ui";

const KEYS = ["address", "opening_hours", "entrance_parking", "visit_arrangement", "pet_policy", "outside_food_policy", "fire_bbq_rules", "accessibility"];

export default function VisitSection() {
  const { content } = useSite();
  const [visit, setVisit] = useState(() => ({ ...content.visit }));
  const { save, saving } = useSaver();
  const onSave = () => save([["visit", Object.fromEntries(KEYS.map((k) => [k, cleanBi(visit[k])]))]]);

  return (
    <section data-testid="admin-section-ziyaret">
      <SectionHeader title="Ziyaret bilgileri" text="Ziyaretini Planla sayfasındaki 8 bilgi kartı. Solda Türkçe, sağda İngilizce; her dil ayrı doğrulanır. Boş veya doğrulanmamış alanlar canlı sitede gizlenir." />
      <div className="grid gap-4 md:grid-cols-2">
        {KEYS.map((k) => (
          <BiFieldEditor key={k} id={`visit-${k}`} label={t(`ziyaret.fields.${k}`)} multiline field={visit[k]} onChange={(f) => setVisit({ ...visit, [k]: f })} />
        ))}
      </div>
      <div className="mt-6"><SaveButton onClick={onSave} saving={saving} testId="admin-save-ziyaret" /></div>
    </section>
  );
}
